export const MAIN_NET = 324;
export const TEST_NET = 300;

export const SOB_ADDRESS_TEST = "0xc2Be8769838ba9c9cD42fb56F2469d9c91cBf124";
export const SOB_ADDRESS_MAIN = "0x814f0a57aeb46c951FCD15B24399620fa366D002";

export const PRESALE_ADDRESS_TEST = "0xea01A4B7038690176Bc65c7f6B4370cADA03Dcc4";
export const PRESALE_ADDRESS_MAIN = "0xa314C05b482a2a2D558b97beE0bb912A3Ba4070a";